import type { AIUnifiedEventPayload } from '@atlaskit/editor-common/analytics';
import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { CommonStepAttributes } from '../../ui/utils/analytics/analyticsFlowTypes';

import type { NextAction, UndoneSession } from './types';

type AiSessionId = string;
type TimeoutId = number;

interface AnalyticsToDefer {
	aiSessionId: AiSessionId;
	payload: AIUnifiedEventPayload;
}

export interface DifferedAnalyticsState {
	differed: Record<AiSessionId, TimeoutId>;
	toCancel?: AiSessionId;
	toDefer?: AnalyticsToDefer;
}

export type CommonAttributes = Partial<CommonStepAttributes>;

export type AIMonitorWatchmenPluginState = {
	commonAttributes: CommonAttributes;
	currentSession: {
		aiOutputChars: number;
		aiOutputWords: number;
		awaitingNextAction: boolean;
		baselineDoc: PMNode;
		id: string;
		mergedNewRanges: Array<{ from: number; to: number }>;
		ranges: { newEnd: number; newStart: number; oldEnd: number; oldStart: number }[];
		startedAt: number;
	} | null;

	differedAnalytics: DifferedAnalyticsState;

	lastUndoneSession: UndoneSession | null;

	pendingAnalytics: {
		aiOutputChars: number;
		aiOutputWords: number;
		aiSessionId: string;
		nextActionLatencyMs: number;
		nextActionRemovedAiChars: number | undefined;
		nextActionRemovedAiWords: number | undefined;
		nextActionTouchedAiRanges: number | undefined;
		nextActionType: NextAction;
	} | null;
};

export const aiMonitorWatchmenPluginKey = new PluginKey<AIMonitorWatchmenPluginState>(
	'aiMonitorWatchmen',
);
